module.exports = __webpack_public_path__ + "static/Safety Accountability -bfd338b3886acdcecece5208e42d8a73.gif";